import React from "react";
import "./App.css";
import Landing from "./pages/Landing.js";
import Signin from "./components/Signin";
import Dashboard from "./pages/Dashboard";
import Navbar from "./components/Navbar";
import ChatRoomsPage from "./pages/ChatRooms";
import { AuthContextProvider } from "./components/AuthContext";
import { Route, Routes } from "react-router-dom";

function App() {
  //creating objects with state to represent event info

  return (
    <div>
      <AuthContextProvider>
        {/* <LocalizationProvider dateAdapter={AdapterDayjs}> */}
        {window.location.pathname !== "/chatroom" ? <Navbar /> : null}
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/signin" element={<Signin />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/chatroom" element={<ChatRoomsPage />} />
        </Routes>

        {/* </LocalizationProvider> */}
      </AuthContextProvider>
    </div>
  );
}

export default App;
